import { z } from "zod";

export const PresentationSchema = z.object({
  title: z.string(),
  description: z.string(),
  link: z.string().url(),
});

export const LocationDescriptionSchema = z.object({
  subtitle: z.string(),
  text: z.string(),
});

export const LocationAdditionalSchema = z.object({
  title: z.string(),
  descriptions: z.object({
    first: LocationDescriptionSchema,
    second: LocationDescriptionSchema,
  }),
});

export const LocationSchema = z.object({
  coordinates: z.tuple([z.number(), z.number()]),
  metro: z.string(),
  districtId: z.number(),
  additional: LocationAdditionalSchema,
});

export const SpecSchema = z.object({
  areaFrom: z.number(),
  floor: z.number(),
  objectCount: z.number()
});

export const FeatureItemSchema = z.object({
  name: z.string(),
  description: z.string(),
});

export const FeaturesSchema = z.object({
  list: z.array(FeatureItemSchema),
  imageUrl: z.string().url(),
});

export const PlanningSchema = z.object({
  schemas: z.array(z.string().url()),
  imageUrl: z.string().url(),
  presentationLink: z.string().url(),
});

export const ProjectSchema = z.object({
  id: z.string(),
  title: z.string(),
  subtitle: z.string(),
  description: z.string(),
  developer: z.string(), 
  imageUrl: z.string().nullable(),
  statusKey: z.string(),
  tierKey: z.string(),
  priceFrom: z.number(),
  rooms: z.array(z.number()),
  startDate: z.string(),
  completionDate: z.string(),
  images: z.array(z.string()),
  presentation: PresentationSchema,
  location: LocationSchema,
  spec: SpecSchema,
  features: FeaturesSchema,
  planning: PlanningSchema,
});

export const ProjectsSchema = z.array(ProjectSchema);

export type ProjectType = z.infer<typeof ProjectSchema>;
export type ProjectsType = z.infer<typeof ProjectsSchema>;
export type ProjectFeaturesType = z.infer<typeof FeaturesSchema>;
export type ProjectPlanType = z.infer<typeof PlanningSchema>;

export type LocationAdditionalType = z.infer<typeof LocationAdditionalSchema>;
export type ProjectPresentationType = z.infer<typeof PresentationSchema>;